import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import SvgIcon from '@components/SvgIcon'
import { SvgIconName } from '@components/SvgIcon/types'

const StyledSvgIcon = styled(SvgIcon)`
  ${({
    theme: {
      spacing: { spacing40 },
    },
  }) => css`
    min-width: ${spacing40};
  `}
`

const StyledPlaceholderWrapper = styled.div`
  ${({
    theme: {
      colors: { textDefault, fillWeak },
      spacing: { spacing8 },
    },
  }) => css`
    color: ${textDefault};
    background-color: ${fillWeak};
    border-radius: ${spacing8};
    box-sizing: border-box;
    height: 100%;
    display: flex;
    width: 100%;
    padding: ${spacing8};
    gap: ${spacing8};
  `}
`
const StyledTextWrapper = styled.div``
const StyledTitle = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          xsmall: { bundledCSS: headingXSmall },
        },
      },
      spacing: { spacing4 },
    },
  }) => css`
    ${headingXSmall};
    margin-bottom: ${spacing4};
  `}
`

const StyledText = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xsmall: { bundledCSS: bodycopyXSmall },
        },
      },
    },
  }) => css`
    ${bodycopyXSmall};
  `}
`

interface RecentMatchOutcomesPlaceholderProps {
  iconName: SvgIconName
  title: string
  text: string
}

const Placeholder: FunctionComponent<RecentMatchOutcomesPlaceholderProps> = ({
  iconName,
  title,
  text,
}) => {
  return (
    <StyledPlaceholderWrapper>
      <StyledSvgIcon iconName={iconName} size={40} />
      <StyledTextWrapper>
        <StyledTitle>{title}</StyledTitle>
        <StyledText>{text}</StyledText>
      </StyledTextWrapper>
    </StyledPlaceholderWrapper>
  )
}

export default Placeholder
